export const classNames = (...args: any[]): string => {
  return args
    .filter(Boolean) // removes null, undefined, false, 0
    .map((arg) => {
      // use "map" so that a new array is returned
      if (Array.isArray(arg)) {
        return classNames(...arg) // spread the array and recurse
      }
      if (typeof arg === 'object') {
        return classNames(
          ...Object.keys(arg) // get the keys
            .filter((key) => arg[key]),
        ) // only keep truthy values
        // spread the result array and recurse
      }
      return arg
    })
    .join(' ') // convert result array to string
}
